import { render, staticRenderFns } from "./CardTarjaEnqueteAngelicaWithQRCode.vue?vue&type=template&id=8537841a&scoped=true"
import script from "./CardTarjaEnqueteAngelicaWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteAngelicaWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteAngelicaWithQRCode.vue?vue&type=style&index=0&id=8537841a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8537841a",
  null
  
)

export default component.exports